import { render, staticRenderFns } from "./VideoConsentForm.vue?vue&type=template&id=69805373&scoped=true"
import script from "./VideoConsentForm.vue?vue&type=script&lang=js"
export * from "./VideoConsentForm.vue?vue&type=script&lang=js"
import style0 from "./VideoConsentForm.vue?vue&type=style&index=0&id=69805373&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69805373",
  null
  
)

export default component.exports